export const GET_RESET_PASSWORD_VERIFICATION_BEGIN = 'GET_RESET_PASSWORD_VERIFICATION_BEGIN'
export const GET_RESET_PASSWORD_VERIFICATION_SUCCESS = 'GET_RESET_PASSWORD_VERIFICATION_SUCCESS'
export const GET_RESET_PASSWORD_VERIFICATION_ERROR = 'GET_RESET_PASSWORD_VERIFICATION_ERROR'

export const FORGOT_PASSWORD_VERIFICATION_BEGIN = 'FORGOT_PASSWORD_VERIFICATION_BEGIN'
export const FORGOT_PASSWORD_VERIFICATION_SUCCESS = 'FORGOT_PASSWORD_VERIFICATION_SUCCESS'
export const FORGOT_PASSWORD_VERIFICATION_ERROR = 'FORGOT_PASSWORD_VERIFICATION_ERROR'

export const RESET_PASSWORD_VERIFICATION_BEGIN = 'RESET_PASSWORD_VERIFICATION_BEGIN'
export const RESET_PASSWORD_VERIFICATION_SUCCESS = 'RESET_PASSWORD_VERIFICATION_SUCCESS'
export const RESET_PASSWORD_VERIFICATION_ERROR = 'RESET_PASSWORD_VERIFICATION_ERROR'

